// Which price list to show: EUR where Stripe charges VAT, USD elsewhere.
//
// The page carries every list and hides all but one. The browser's languages
// pick the first one shown, a remembered choice overrides that, and the
// toggle sets both.

// The countries Stripe charges VAT in. A region tag from one of these picks
// EUR whatever the language.
const VAT_REGIONS = new Set([
  "AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "HU",
  "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT", "RO", "SK", "SI", "ES",
  "SE", "MC", "AD", "SM", "VA", "XK", "ME",
])

// Languages spoken mostly inside those countries, for a tag with no region.
// English, Spanish, Portuguese and French are left out: most of their
// speakers are elsewhere.
const VAT_LANGUAGES = new Set([
  "bg", "hr", "cs", "da", "nl", "et", "fi", "de", "el", "hu", "ga", "it", "lv",
  "lt", "mt", "pl", "ro", "sk", "sl", "sv",
])

export const CURRENCIES = ["EUR", "USD"]
const STORAGE_KEY = "inboxctl.currency"

// The currency the first decisive language tag asks for. A tag with a region
// decides by the region; a bare language decides by the language; anything
// unparseable is skipped. No tags at all means EUR, the list the page shows
// without scripts.
export const inferCurrency = (languages) => {
  for (const tag of languages || []) {
    const parts = String(tag).split(/[-_]/)
    const language = parts[0]?.toLowerCase()
    const region = parts.find((part, i) => i > 0 && /^[A-Za-z]{2}$/.test(part))?.toUpperCase()
    if (!language) continue
    if (region) return VAT_REGIONS.has(region) ? "EUR" : "USD"
    return VAT_LANGUAGES.has(language) ? "EUR" : "USD"
  }
  return "EUR"
}

const remembered = () => {
  try {
    const value = localStorage.getItem(STORAGE_KEY)
    return CURRENCIES.includes(value) ? value : null
  } catch {
    return null
  }
}

const remember = (currency) => {
  try {
    localStorage.setItem(STORAGE_KEY, currency)
  } catch {
    // Private windows and blocked storage fall back to inferring each visit.
  }
}

export const showCurrency = (root, currency) => {
  root.querySelectorAll(".plans [data-currency]").forEach((node) => {
    node.hidden = node.dataset.currency !== currency
  })
  root.querySelectorAll(".plans").forEach((list) => {
    list.dataset.currency = currency
  })
  root.querySelectorAll("[data-currency-toggle] [data-currency]").forEach((button) => {
    button.setAttribute("aria-pressed", String(button.dataset.currency === currency))
  })
}

export const armCurrency = (root = document) => {
  const toggle = root.querySelector("[data-currency-toggle]")
  if (!toggle) return

  showCurrency(root, remembered() || inferCurrency(navigator.languages || [navigator.language]))

  toggle.querySelectorAll("[data-currency]").forEach((button) => {
    button.addEventListener("click", () => {
      showCurrency(root, button.dataset.currency)
      remember(button.dataset.currency)
    })
  })
}
